/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System ViewCards Icon component.
 */
export const SystemViewCardsIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='SystemViewCardsIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M21 10.1V4H2v6.1h19zM21 20.2v-6.1H2v6.1h19z'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
      </svg>
    )} />
  );
};
